module.exports = __webpack_public_path__ + "static/media/onlineShop.3be3ed1a.jpg";